import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Fragment, Suspense, useMemo, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { array, number, shape, string } from 'prop-types';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { useCategoryContent } from '@magento/peregrine/lib/talons/RootComponents/Category';
import FilterModalOpenButton, { FilterModalOpenButtonShimmer } from '@magento/venia-ui/lib/components/FilterModalOpenButton';
import { FilterSidebarShimmer } from '@magento/venia-ui/lib/components/FilterSidebar';
import { GalleryShimmer } from '@magento/venia-ui/lib/components/Gallery';
import Breadcrumbs from '@magento/venia-ui/lib/components/Breadcrumbs';
import classes from './searchPage.module.css'; // import NoProductsFound from './NoProductsFound';

import ErrorView from '@magento/venia-ui/lib/components/ErrorView';
import { Gallery, ProductsLayout, Pagination, Button } from '../../../../components';
import RichContent from '@magento/venia-ui/lib/components/RichContent';
import ProductsListHeader from '../../../../RootComponents/Category/productsListHeader'; // import { AddToFavouritesModal, AddFrequentlyOrderModal, DownloadProjectModal } from './Modals';

import SubCategoryBox from '../../../../RootComponents/Category/subCategoryBox';
import LoadingIndicator from '@magento/venia-ui/lib/components/LoadingIndicator';
import UseKlevuSearchResults, { useQuery } from './useKlevuSearchResults';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import { useSearchPage } from '@magento/peregrine/lib/talons/SearchPage/useSearchPage';
import fetchCustomAttribute from './customAttributeFetch';
import { useLazyQuery } from '@apollo/client';
import { GET_GROUPED_PRODUCTS_PRICES } from '../../../../RootComponents/Category/category.gql';
import { calculatePriceRange } from '../../../../RootComponents/Category/category';
var FilterModal = React.lazy(function () {
  return import('../../../../components/FilterModal');
});
var FilterSidebar = React.lazy(function () {
  return import('../../../../components/FilterSidebar');
});

var SearchPage = function SearchPage(_ref) {
  var _klevuProducts$meta, _klevuProducts$meta2, _klevuProducts$meta$t, _klevuProducts$meta3, _klevuProducts$meta4, _klevuProducts$meta5;

  var categoryId = _ref.categoryId,
      isLoading = _ref.isLoading;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      _useUserContext2$ = _useUserContext2[0],
      isSignedIn = _useUserContext2$.isSignedIn,
      currentUser = _useUserContext2$.currentUser;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFiltersHidden = _useState2[0],
      setIsFiltersHidden = _useState2[1];

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 980;
  var customerGroupId = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.group_uid) !== 0 ? window.atob(currentUser === null || currentUser === void 0 ? void 0 : currentUser.group_uid) : 0;

  var _fetchCustomAttribute = fetchCustomAttribute(),
      swatchData = _fetchCustomAttribute.data,
      swatchLoading = _fetchCustomAttribute.loading,
      swatchError = _fetchCustomAttribute.error;

  var query = useQuery();
  var isTablet = innerWidth <= 1024;

  var _UseKlevuSearchResult = UseKlevuSearchResults(isSignedIn, customerGroupId, {
    query_string: 'query',
    type: 'search',
    can_search: true,
    query: query
  }),
      klevuProducts = _UseKlevuSearchResult.products,
      klevuFilters = _UseKlevuSearchResult.options,
      magentoProducts = _UseKlevuSearchResult.magentoProducts,
      klevuManager = _UseKlevuSearchResult.manager,
      klevuSortingOptions = _UseKlevuSearchResult.klevuSortingOptions,
      sorting = _UseKlevuSearchResult.sorting,
      setSorting = _UseKlevuSearchResult.setSorting,
      klevuLoading = _UseKlevuSearchResult.klevuLoading,
      initialFetch = _UseKlevuSearchResult.initialFetch,
      pageSize = _UseKlevuSearchResult.pageSize,
      setPageSize = _UseKlevuSearchResult.setPageSize;

  var _useState3 = useState(4),
      _useState4 = _slicedToArray(_useState3, 2),
      gridCols = _useState4[0],
      setGridCols = _useState4[1];

  var _useLazyQuery = useLazyQuery(GET_GROUPED_PRODUCTS_PRICES, {
    fetchPolicy: 'no-cache' // nextFetchPolicy: 'cache-first'

  }),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      runQuery = _useLazyQuery2[0],
      outletPriceRangeData = _useLazyQuery2[1].data;

  useEffect(function () {
    return isTablet && gridCols === 4 && setGridCols(3);
  }, [gridCols, isTablet]);
  var outletSkus = useMemo(function () {
    return magentoProducts.filter(function (magentoProduct) {
      return magentoProduct.sku.startsWith('OUT-');
    }).map(function (item) {
      return item.sku;
    });
  }, [magentoProducts]);
  useEffect(function () {
    if (outletSkus.length > 0) {
      runQuery({
        variables: {
          skus: outletSkus
        }
      });
    }
  }, [outletSkus, runQuery]);
  var outletPriceRange = useMemo(function () {
    var _outletPriceRangeData, _outletPriceRangeData2;

    return outletPriceRangeData === null || outletPriceRangeData === void 0 ? void 0 : (_outletPriceRangeData = outletPriceRangeData.products) === null || _outletPriceRangeData === void 0 ? void 0 : (_outletPriceRangeData2 = _outletPriceRangeData.items) === null || _outletPriceRangeData2 === void 0 ? void 0 : _outletPriceRangeData2.filter(function (item) {
      var _item$items;

      return item.__typename == 'GroupedProduct' && (item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length) > 0;
    }).map(function (item) {
      return {
        sku: item.sku,
        price_range: calculatePriceRange(item === null || item === void 0 ? void 0 : item.items)
      };
    }).filter(function (item) {
      return item.price_range;
    });
  }, [outletPriceRangeData]);
  var talonProps = useSearchPage({
    query: query.get('query')
  });
  var pageControl = talonProps.pageControl,
      sortProps = talonProps.sortProps,
      pageSizeValues = talonProps.pageSizeValues;
  var transformedFilters = useMemo(function () {
    return klevuFilters.map(function (kItem) {
      var _kItem$options;

      var options = kItem === null || kItem === void 0 ? void 0 : (_kItem$options = kItem.options) === null || _kItem$options === void 0 ? void 0 : _kItem$options.map(function (option) {
        var _swatchData$customAtt, _swatchData$customAtt2, _swatchData$customAtt3, _swatchData$customAtt4, _swatchData$customAtt5;

        return _objectSpread(_objectSpread({}, option), {}, {
          swatch_data: swatchData === null || swatchData === void 0 ? void 0 : (_swatchData$customAtt = swatchData.customAttributeMetadata) === null || _swatchData$customAtt === void 0 ? void 0 : (_swatchData$customAtt2 = _swatchData$customAtt.items) === null || _swatchData$customAtt2 === void 0 ? void 0 : (_swatchData$customAtt3 = _swatchData$customAtt2.find(function (item) {
            return (item === null || item === void 0 ? void 0 : item.attribute_code) === (item === null || item === void 0 ? void 0 : item.attribute_code);
          })) === null || _swatchData$customAtt3 === void 0 ? void 0 : (_swatchData$customAtt4 = _swatchData$customAtt3.attribute_options) === null || _swatchData$customAtt4 === void 0 ? void 0 : (_swatchData$customAtt5 = _swatchData$customAtt4.find(function (attributeOption) {
            return attributeOption.label === option.value;
          })) === null || _swatchData$customAtt5 === void 0 ? void 0 : _swatchData$customAtt5.swatch_data
        });
      });
      kItem.options = options;
      return kItem;
    });
  }, [klevuFilters, swatchData]); // const {
  //     categoryName,
  //     categoryDescription,
  //     displayMode,
  //     subCategories,
  //     filters,
  //     items,
  //     totalCount,
  //     totalPagesFromData
  // } = useCategoryContent({
  //     categoryId,
  //     data,
  //     pageSize
  // });
  // const shouldRenderSidebarContent = useIsInViewport({
  //   elementRef: sidebarRef
  // });

  var productsCount = klevuProducts && klevuProducts !== null && klevuProducts !== void 0 && klevuProducts.meta && klevuProducts !== null && klevuProducts !== void 0 && (_klevuProducts$meta = klevuProducts.meta) !== null && _klevuProducts$meta !== void 0 && _klevuProducts$meta.totalResultsFound ? klevuProducts === null || klevuProducts === void 0 ? void 0 : (_klevuProducts$meta2 = klevuProducts.meta) === null || _klevuProducts$meta2 === void 0 ? void 0 : _klevuProducts$meta2.totalResultsFound : 0;
  var totalCount = (_klevuProducts$meta$t = klevuProducts === null || klevuProducts === void 0 ? void 0 : (_klevuProducts$meta3 = klevuProducts.meta) === null || _klevuProducts$meta3 === void 0 ? void 0 : _klevuProducts$meta3.totalResultsFound) !== null && _klevuProducts$meta$t !== void 0 ? _klevuProducts$meta$t : 0;

  var toggleFiltersSidebar = function toggleFiltersSidebar() {
    return setIsFiltersHidden(function (prevState) {
      return !prevState;
    });
  };

  var shouldShowFilterButtons = klevuFilters && klevuFilters.length;
  var shouldShowFilterShimmer = klevuFilters === null; // If there are no products we can hide the sort button.

  var shouldShowSortButtons = productsCount && klevuSortingOptions;
  var shouldShowSortShimmer = !productsCount && klevuLoading;
  var filtersModal = shouldShowFilterButtons ? React.createElement(FilterModal, {
    filters: transformedFilters // filterCategoryData={filterCategoryData}
    ,
    totalCount: totalCount // filters={filters}
    // categoryId={categoryId}

  }) : null;
  var maybeFilterButtons = shouldShowFilterButtons ? React.createElement(FilterModalOpenButton, {
    filters: transformedFilters
  }) : shouldShowFilterShimmer ? React.createElement(FilterModalOpenButtonShimmer, null) : null;
  var sidebar = shouldShowFilterButtons && !isSmallDevice ? React.createElement(FilterSidebar // filterCategoryData={filterCategoryData}
  // filters={filters}
  // categoryId={categoryId}
  , {
    filters: transformedFilters,
    klevuFilterManager: klevuManager
  }) : shouldShowFilterShimmer ? React.createElement(FilterSidebarShimmer, null) : null;
  var totalPagesFromData = Math.ceil((klevuProducts === null || klevuProducts === void 0 ? void 0 : (_klevuProducts$meta4 = klevuProducts.meta) === null || _klevuProducts$meta4 === void 0 ? void 0 : _klevuProducts$meta4.totalResultsFound) / (klevuProducts === null || klevuProducts === void 0 ? void 0 : (_klevuProducts$meta5 = klevuProducts.meta) === null || _klevuProducts$meta5 === void 0 ? void 0 : _klevuProducts$meta5.noOfResults)); // TODO add shimmer

  var productsListHeader = shouldShowFilterButtons ? React.createElement(ProductsListHeader, {
    toggleFiltersSidebar: toggleFiltersSidebar,
    isFiltersHidden: isFiltersHidden,
    filters: klevuFilters,
    pageControl: {
      currentPage: pageControl === null || pageControl === void 0 ? void 0 : pageControl.currentPage,
      setPage: pageControl === null || pageControl === void 0 ? void 0 : pageControl.setPage,
      totalPages: totalPagesFromData
    },
    totalCount: totalCount,
    isLoading: klevuLoading,
    sortProps: sortProps,
    klevuSortProps: [sorting, setSorting],
    availableSortMethods: klevuSortingOptions,
    useKlevuSort: true,
    totalPagesFromData: totalPagesFromData,
    klevuFilterManager: klevuManager,
    initialFetch: initialFetch,
    pageSize: pageSize,
    setPageSize: setPageSize,
    pageSizeValues: pageSizeValues,
    gridCols: gridCols,
    setGridCols: setGridCols
  }) : null; // const categoryDescriptionElement = categoryDescription ? (
  //     <RichContent html={categoryDescription} />
  // ) : null;

  var isError = useMemo(function () {
    if (!totalPagesFromData && !klevuLoading) {// return <ErrorView />;
    }

    return null;
  }, [categoryId, classes.gallery, classes.pagination, klevuLoading, klevuProducts, pageControl, totalPagesFromData]);
  var content = useMemo(function () {
    var gallery = totalPagesFromData ? React.createElement(Gallery, {
      items: magentoProducts,
      pageControl: {
        currentPage: pageControl === null || pageControl === void 0 ? void 0 : pageControl.currentPage,
        setPage: pageControl === null || pageControl === void 0 ? void 0 : pageControl.setPage,
        totalPages: totalPagesFromData
      },
      isCollectionBtnAllowed: true,
      outletPriceRange: outletPriceRange,
      gridCols: gridCols
    }) : React.createElement(GalleryShimmer, {
      items: magentoProducts
    });

    if (!totalPagesFromData && !isLoading) {
      return React.createElement("p", null, "No items found with your current selection.");
    }

    return React.createElement(Fragment, null, gallery);
  }, [categoryId, classes.gallery, classes.pagination, isLoading, klevuProducts, pageControl, totalPagesFromData, gridCols]);
  var pagination = shouldShowSortButtons ? React.createElement(Pagination, {
    bottomPagination: true,
    pageControl: {
      currentPage: pageControl === null || pageControl === void 0 ? void 0 : pageControl.currentPage,
      setPage: pageControl === null || pageControl === void 0 ? void 0 : pageControl.setPage,
      totalPages: totalPagesFromData
    },
    pageSize: pageSize,
    setPageSize: setPageSize,
    pageSizeValues: pageSizeValues
  }) : null; // const categoryTitle = categoryName ? categoryName : <Shimmer width={5} />;

  var rightPartStyle;
  var leftPartStyle;

  if (isSmallDevice) {
    rightPartStyle = {
      width: '100%'
    };
    leftPartStyle = {
      display: 'none'
    };
  } else {
    if (isFiltersHidden) {
      rightPartStyle = {
        width: '100%',
        transition: 'width 0.3s ease-out'
      };
      leftPartStyle = {
        visibility: 'hidden',
        width: '0%',
        transition: 'width 0.3s ease-out'
      };
    } else {
      rightPartStyle = {
        width: '85%',
        transition: 'width .03s ease-in'
      };
      leftPartStyle = {
        width: ' 25%',
        marginRight: '20px',
        transition: 'width 0.3s ease-in'
      };
    }
  } // const subCategoriesGrid = subCategories?.map((subcategory, idx) => (
  //     <SubCategoryBox key={idx} subcategory={subcategory} />
  // ));
  // const categoriesGrid = subCategories?.map((item, idx) => (
  //     <CategoryItem key={idx} item={item} />
  // ));


  if (klevuLoading && swatchLoading) {
    return React.createElement(LoadingIndicator, null);
  }

  var searchQuery = query === null || query === void 0 ? void 0 : query.get('query');
  var title = "Search results for \"".concat(searchQuery, "\"");
  return React.createElement(React.Fragment, null, isError ? React.createElement(ErrorView, null) : React.createElement(ProductsLayout, null, React.createElement(Breadcrumbs, {
    categoryId: categoryId,
    text: title,
    search: searchQuery,
    classes: {
      root: classes.breadcrumbs
    }
  }), productsListHeader, React.createElement("div", {
    className: "flex"
  }, React.createElement("div", {
    style: leftPartStyle
  }, sidebar), React.createElement("div", {
    style: rightPartStyle
  }, content)), React.createElement("div", {
    className: "mb-40"
  }, " ", pagination), React.createElement(Suspense, {
    fallback: null
  }, filtersModal)));
};

export default SearchPage;
SearchPage.propTypes = {
  classes: shape({
    gallery: string,
    pagination: string,
    root: string,
    categoryHeader: string,
    title: string,
    categoryTitle: string,
    sidebar: string,
    categoryContent: string,
    heading: string,
    categoryInfo: string,
    headerButtons: string
  }),
  // sortProps contains the following structure:
  // [{sortDirection: string, sortAttribute: string, sortText: string},
  // React.Dispatch<React.SetStateAction<{sortDirection: string, sortAttribute: string, sortText: string}]
  sortProps: array,
  pageSize: number
}; // const maybeSortContainer = shouldShowSortButtons ? (
//   <SortedByContainer currentSort={currentSort} />
// ) : shouldShowSortShimmer ? (
//   <SortedByContainerShimmer />
// ) : null;
// const categoryDescriptionElement = categoryDescription ? (
//   <RichContent html={categoryDescription} />
// ) : null;